import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import MaklumatPelanggan from "../../page/MaklumatPelanggan";

function Overview() {
  // State to hold selected profile data
  const [selectedProfile, setSelectedProfile] = useState(null);

  // Helper to handle card click and set selected profile
  const handleProjectCardClick = (author) => {
    setSelectedProfile(author);
  };

  // Example: Use the first author of each project as the "main" person for the card

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
        <MDBox p={2}>
          <Grid container spacing={6}>
            {projects.map((project, idx) => (
              <Grid item xs={12} md={6} xl={3} key={idx}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handleProjectCardClick(project.authors[0])}
                >
                  <DefaultProjectCard
                    image={project.image}
                    label={project.label}
                    title={project.title}
                    description={project.description}
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "info",
                      label: "view project",
                    }}
                    authors={project.authors}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </MDBox>
        {/* Show MaklumatPelanggan if a profile is selected */}
        {selectedProfile && (
          <MDBox mt={4}>
            <MaklumatPelanggan profile={selectedProfile} onClose={() => setSelectedProfile(null)} />
          </MDBox>
        )}
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
